// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Aovg_G6KI1e3gEzump4BL"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Desktop/Volume/styles.css
// module id = 1606
// module chunks = 85